import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Commands as GenericCommands } from '../../../../services/commands/commands';

@Injectable({
  providedIn: 'root'
})
export class Commands extends GenericCommands {

  constructor(protected override http: HttpClient){
    super(http, 'mind-link');
  }

  public selectPlayer(

    is_leader: boolean,
    successCallback?: Function

  ): void {

    this.postCommand(
      'player:select',
      is_leader ? 'leader' : 'prompter',
      successCallback
    );

  }

  public startRound(

    sync_time: number,
    is_double_mode: boolean,
    successCallback?: Function

  ): void {

    this.postCommand(
      'round:start',
      { sync_time, is_double_mode },
      successCallback
    );

  }

  public endRound(

    time: number,
    successCallback?: Function

  ): void {
  
    this.postCommand(
      'round:end',
      { time },
      successCallback
    );

  }

  public passWord(
    successCallback?: Function
  ): void {

    this.postCommand(
      'word:pass',
      null,
      successCallback
    );

  }

  public updatePoints(

    points: number,
    successCallback?: Function

  ): void {

    this.postCommand(
      'points:update',
      points,
      successCallback
    );

  }

  public endGame(
    successCallback?: Function
  ): void {

    this.postCommand(
      'game:end',
      null,
      successCallback
    );

  }

}
